// import { Component, OnInit, ViewChild } from '@angular/core';
// import { NavigationEnd, Router } from '@angular/router';
// import { NbAuthService } from '@nebular/auth';
// import { NbSidebarService, NbMenuService, NbThemeService, NbMediaBreakpointsService, NbToastrService, NbPopoverDirective, NbGlobalPhysicalPosition } from '@nebular/theme';
// import { filter, map, takeUntil } from 'rxjs/operators';

// import { AuthService } from '../../../services/auth.service';
// import { AppNotification, NotificationService } from '../../../services/notification.service';
// import { Subject, Subscription } from 'rxjs';
// import { deleteDoc, doc, Firestore } from '@angular/fire/firestore';

// @Component({
//   selector: 'ngx-one-column-layout',
//   styleUrls: ['./one-column.layout.scss'],
//   template: `
//     <nb-layout windowMode>
//       <nb-layout-header fixed>
//         <ngx-header></ngx-header>
//       </nb-layout-header>

// <nb-sidebar
//   class="menu-sidebar"
//   tag="menu-sidebar"
//   (mouseenter)="onSidebarHover(true)"
//   (mouseleave)="onSidebarHover(false)"
// >
//         <div class="allitem">
//         <ng-content select="nb-menu"></ng-content>
//         <div class="others">

//           <div class="sidebar-wrapper">

//       <!-- TOP BAR -->
//       <div class="sidebar-top">



//         <!-- <div class="internet-status" [ngClass]="isOnline ? 'online' : 'offline'">
//           <span *ngIf="isOnline">🟢 Online – {{ internetSpeed }}</span>
//           <span *ngIf="!isOnline">🔴 Offline</span>
//         </div> -->

//         <div class="top-actions">

//           <!-- <nb-search size="tiny"></nb-search> -->




// <nb-user
//   *nbIsGranted="['view', 'user']"
//   [nbContextMenu]="userMenu"

//   [onlyPicture]="isSidebarCompact"
//   [name]="!isSidebarCompact ? profileData?.name : null"
//   [role]="!isSidebarCompact ? profileData?.role : null"
//   [picture]="profileData?.profileImage"

//   (nbContextMenuItemClick)="onMenuItemClick($event)">
// </nb-user>



//         </div>
//       </div>



//     </div>
//         </div>
//         </div>
//       </nb-sidebar>

// <nb-layout-column class="main-workspace-column">
//   <ng-content select=".page-workspace"></ng-content>
// </nb-layout-column>

//       <nb-layout-footer fixed>
//         <ngx-footer></ngx-footer>
//       </nb-layout-footer>
//     </nb-layout>
//   `,
// })
// export class OneColumnLayoutComponent implements OnInit {

//   private destroy$ = new Subject<void>();
//   @ViewChild(NbPopoverDirective) nbPopoverDirective!: NbPopoverDirective;

//   userPictureOnly = false;
//   user: any;
//   profileData: Record<string, any> = {};


//   currentTheme = 'default';
//   userMenu = [{ title: 'Profile' }, { title: 'Log out' }];
//   private profileSub!: Subscription;
//   isMobile = false;
//   isSidebarCompact = false;

//   constructor(
//     private sidebarService: NbSidebarService,
//     private menuService: NbMenuService,
//     private themeService: NbThemeService,

//     private breakpointService: NbMediaBreakpointsService,
//     private authService: NbAuthService,
//     private router: Router,
//     private authProfileService: AuthService,
//     private firestore: Firestore,
//     private toastr: NbToastrService,


//   ) {
//     // Menu actions handle
//     const { md } = this.breakpointService.getBreakpointsMap();

//     this.themeService.onMediaQueryChange()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe(([, bp]) => {
//         this.isMobile = bp.width < md;

//         if (this.isMobile) {
//           this.sidebarService.expand('menu-sidebar');
//             this.isSidebarCompact = false; // 👈 add this

//         } else {
//           this.sidebarService.compact('menu-sidebar');
//         }
//       });
//     this.menuService
//       .onItemClick()
//       .pipe(
//         takeUntil(this.destroy$),
//         map(({ item }) => item.title),
//         filter(title => title === 'Log out' || title === 'Profile')
//       )
//       .subscribe(title => {
//         if (title === 'Log out') this.logout();
//         if (title === 'Profile') this.router.navigate(['/pages/profile']);
//       });
//   }
//   openEmail() {
//     this.router.navigate(['/pages/extra-components/chat']);
//   }
//   private hoverTimer: any = null;
//   private isSidebarOpen = false;

//   onSidebarHover(hovered: boolean) {
//     if (this.isMobile) return;

//     if (this.hoverTimer) {
//       clearTimeout(this.hoverTimer);
//       this.hoverTimer = null;
//     }

//     this.hoverTimer = setTimeout(() => {
//       if (hovered && this.isSidebarCompact) {
//         this.sidebarService.expand('menu-sidebar');
//         this.isSidebarCompact = false;
//       }

//       if (!hovered && !this.isSidebarCompact) {
//         this.sidebarService.compact('menu-sidebar');
//         this.isSidebarCompact = true;
//       }
//     }, 1);
//   }




//   async ngOnInit() {

//     // Sidebar compact on navigation


//     // Current theme
//     this.currentTheme = this.themeService.currentTheme;
//     // ✅ 1) Load the profile first
//     this.profileSub = this.authProfileService
//       .getCurrentUserProfile()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe((data: any) => {

//         if (!data || !data.uid) return;

//         this.profileData = data;

//         // 🛑 Once the profile is available, do not run again
//         this.profileSub.unsubscribe();

//         // ✅ 2) Now listen for notifications (profile ready)


//         // ✅ 3) Notification stream (after the profile loads)

//         // 🔔 Toast + sound (profile-safe)


//       });


//     // Load user info


//     // Responsive user picture
//     const { xl } = this.breakpointService.getBreakpointsMap();
//     this.themeService
//       .onMediaQueryChange()
//       .pipe(
//         map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
//         takeUntil(this.destroy$)
//       )
//       .subscribe(isLessThanXl => (this.userPictureOnly = isLessThanXl));

//     // Theme change
//     this.themeService
//       .onThemeChange()
//       .pipe(
//         map(({ name }) => name),
//         takeUntil(this.destroy$)
//       )
//       .subscribe(themeName => (this.currentTheme = themeName));

//     // Network status listeners

//   }
//   // 🔹 Toast show


//   // 🔹 Sound play (optional)








//   ngOnDestroy() {
//     this.destroy$.next();
//     this.destroy$.complete();

//   }

//   // Network status


//   // Internet speed test


//   // Menu actions
//   onMenuItemClick(item: any) {
//     if (item.title === 'Log out') this.logout();
//     if (item.title === 'Profile') this.router.navigate(['/pages/profile']);
//   }

//   logout() {
//     this.authService.logout('email').subscribe(() => {
//       this.router.navigate(['/auth/login']);
//     });
//   }

//   changeTheme(themeName: string) {
//     this.themeService.changeTheme(themeName);
//   }

//   toggleSidebar(): boolean {
//     this.sidebarService.toggle(true, 'menu-sidebar');

//     return false;
//   }

//   navigateHome() {
//     this.menuService.navigateHome();
//     return false;
//   }
// }
import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { NbSidebarService, NbMenuService, NbThemeService, NbMediaBreakpointsService, NbToastrService, NbPopoverDirective, NbGlobalPhysicalPosition } from '@nebular/theme';
import { filter, map, takeUntil } from 'rxjs/operators';

import { AuthService } from '../../../services/auth.service';
import { AppNotification, NotificationService } from '../../../services/notification.service';
import { Subject, Subscription } from 'rxjs';
import { deleteDoc, doc, Firestore } from '@angular/fire/firestore';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

<nb-sidebar
  class="menu-sidebar"
  tag="menu-sidebar"
  (mouseenter)="onSidebarHover(true)"
  (mouseleave)="onSidebarHover(false)"
>
        <div class="allitem">
          <ng-content select=".sidebar-menu-search"></ng-content>
        <ng-content select="nb-menu"></ng-content>
        <div class="others">

          <div class="sidebar-wrapper">

      <!-- TOP BAR -->
      <div class="sidebar-top">



        <!-- <div class="internet-status" [ngClass]="isOnline ? 'online' : 'offline'">
          <span *ngIf="isOnline">🟢 Online – {{ internetSpeed }}</span>
          <span *ngIf="!isOnline">🔴 Offline</span>
        </div> -->

        <div class="top-actions">

          <!-- <nb-search size="tiny"></nb-search> -->




<nb-user
  *nbIsGranted="['view', 'user']"
  [nbContextMenu]="userMenu"

  [onlyPicture]="isSidebarCompact"
  [name]="!isSidebarCompact ? profileData?.name : null"
  [role]="!isSidebarCompact ? profileData?.role : null"
  [picture]="profileData?.profileImage"

  (nbContextMenuItemClick)="onMenuItemClick($event)">
</nb-user>



        </div>
      </div>



    </div>
        </div>
        </div>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select=".page-workspace"></ng-content>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnInit {

  private destroy$ = new Subject<void>();
  @ViewChild(NbPopoverDirective) nbPopoverDirective!: NbPopoverDirective;

  userPictureOnly = false;
  user: any;
  profileData: Record<string, any> = {};


  currentTheme = 'default';
  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];
  private profileSub!: Subscription;
  isMobile = false;
  isSidebarCompact = false;

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,

    private breakpointService: NbMediaBreakpointsService,
    private authService: NbAuthService,
    private router: Router,
    private authProfileService: AuthService,
    private firestore: Firestore,
    private toastr: NbToastrService,


  ) {
    // Menu actions handle
    const { md } = this.breakpointService.getBreakpointsMap();

    this.themeService.onMediaQueryChange()
      .pipe(takeUntil(this.destroy$))
      .subscribe(([, bp]) => {
        this.isMobile = bp.width < md;

        if (this.isMobile) {
          this.sidebarService.expand('menu-sidebar');
          this.isSidebarCompact = false; // 👈 add this

        } else {
          this.sidebarService.compact('menu-sidebar');
        }
      });
    this.menuService
      .onItemClick()
      .pipe(
        takeUntil(this.destroy$),
        map(({ item }) => item.title),
        filter(title => title === 'Log out' || title === 'Profile')
      )
      .subscribe(title => {
        if (title === 'Log out') this.logout();
        if (title === 'Profile') this.router.navigate(['/pages/profile']);
      });
  }
  openEmail() {
    this.router.navigate(['/pages/extra-components/chat']);
  }
  private hoverTimer: any = null;
  private isSidebarOpen = false;

  onSidebarHover(hovered: boolean) {
    if (this.isMobile) return;

    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = null;
    }

    this.hoverTimer = setTimeout(() => {
      if (hovered && this.isSidebarCompact) {
        this.sidebarService.expand('menu-sidebar');
        this.isSidebarCompact = false;
      }

      if (!hovered && !this.isSidebarCompact) {
        this.sidebarService.compact('menu-sidebar');
        this.isSidebarCompact = true;
      }
    }, 1);
  }




  async ngOnInit() {

    // Sidebar compact on navigation


    // Current theme
    this.currentTheme = this.themeService.currentTheme;
    // ✅ 1) Load the profile first
    this.profileSub = this.authProfileService
      .getCurrentUserProfile()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {

        if (!data || !data.uid) return;

        this.profileData = data;

        // 🛑 Once the profile is available, do not run again
        this.profileSub.unsubscribe();

        // ✅ 2) Now listen for notifications (profile ready)


        // ✅ 3) Notification stream (after the profile loads)

        // 🔔 Toast + sound (profile-safe)


      });


    // Load user info


    // Responsive user picture
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(isLessThanXl => (this.userPictureOnly = isLessThanXl));

    // Theme change
    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe(themeName => (this.currentTheme = themeName));

    // Network status listeners

  }
  // 🔹 Toast show


  // 🔹 Sound play (optional)








  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

  }

  // Network status


  // Internet speed test


  // Menu actions
  onMenuItemClick(item: any) {
    if (item.title === 'Log out') this.logout();
    if (item.title === 'Profile') this.router.navigate(['/pages/profile']);
  }

  logout() {
    this.authService.logout('email').subscribe(() => {
      this.router.navigate(['/auth/login']);
    });
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
